/** L'elenco delle anomalie di una commessa, dal lato della pagina. */
import { get } from '../api'

export type AnomalyStatus = 'waiting' | 'confirmed' | 'rejected'

export interface AnomalyRow {
  detection_id: string
  code: string
  description: string
  level: number | null
  final_level: number | null
  source: string
  confidence: number | null
  status: AnomalyStatus
  reason_code: string | null
  reason_label: string | null
  decided_by: string | null
  decided_at: string | null
  element_id: string | null
  external_element_id: number | null
  element_type: string | null
  photo_id: string | null
  photo_filename: string | null
  thumbnail_url: string | null
  exportable: boolean
  measured_distance_m?: number | null
  minimum_distance_m?: number | null
}

export interface AnomalyCounts {
  total: number
  waiting: number
  confirmed: number
  rejected: number
}

export interface Anomalies {
  inspection_id: string
  total: number
  counts: AnomalyCounts
  rows: AnomalyRow[]
}

export interface AnomalyFilters {
  status: AnomalyStatus | null
  rank: number | null
  q: string | null
  limit?: number
  offset?: number
}

export const PAGE = 100

export function anomalies(inspectionId: string, filters: AnomalyFilters): Promise<Anomalies> {
  const query = new URLSearchParams()
  if (filters.status !== null) query.set('status', filters.status)
  if (filters.rank !== null) query.set('rank', String(filters.rank))
  if (filters.q) query.set('q', filters.q)
  query.set('limit', String(filters.limit ?? PAGE))
  query.set('offset', String(filters.offset ?? 0))
  return get<Anomalies>(`/inspections/${encodeURIComponent(inspectionId)}/anomalies?${query.toString()}`)
}

/** Un passo della storia di un'anomalia (GI-251). */
export interface AnomalyEvent {
  kind: 'predicted' | 'declared' | 'measured' | 'confirmed' | 'rejected' | 'withdrawn'
  at: string
  who: string | null
  level: number | null
  reason_code: string | null
  reason_label: string | null
  corrected: boolean
}

export interface AnomalyHistory {
  detection_id: string
  events: AnomalyEvent[]
}

export function history(inspectionId: string, detectionId: string): Promise<AnomalyHistory> {
  return get<AnomalyHistory>(
    `/inspections/${encodeURIComponent(inspectionId)}/anomalies/${encodeURIComponent(detectionId)}/history`,
  )
}

/** Dove sta il lembo di nuvola di un'anomalia, e come leggerlo (GI-241). */
export interface CloudSwatch {
  detection_id: string
  available: boolean
  url: string | null
  radius_m: number
  measured_distance_m: number | null
  minimum_distance_m: number | null
  classes: Record<string, string>
}

export function cloud(inspectionId: string, detectionId: string): Promise<CloudSwatch> {
  return get<CloudSwatch>(
    `/inspections/${encodeURIComponent(inspectionId)}/anomalies/${encodeURIComponent(detectionId)}/cloud`,
  )
}
